import { mapActions } from "vuex";

export const userListsMixin = {
  data() {
    return {
      tab: "web",
      usersWeb: [],
      usersMobile: [],
    };
  },

  computed: {
    headersWeb() {
      return [
        {
          text: this.$i18n.t("Name"),
          align: "left",
          value: "name",
          width: "30%",
        },
        {
          text: this.$i18n.t("Username"),
          align: "left",
          value: "username",
          width: "25%",
          hasFilter: true,
        },
        {
          text: this.$i18n.t("Email"),
          align: "left",
          value: "email",
          width: "25%",
          hasFilter: true,
        },
        {
          text: this.$i18n.t("Status"),
          align: "left",
          value: "status",
          width: "20%"
        }
      ];
    },
    headersMobile() {
      return [
        {
          text: this.$i18n.t("Name"),
          align: "left",
          value: "name",
          width: "30%",
        },
        {
          text: this.$i18n.t("Username"),
          align: "left",
          value: "username",
          width: "25%",
          hasFilter: true,
        },
        {
          text: this.$i18n.t("Email"),
          align: "left",
          value: "email",
          width: "25%",
          hasFilter: true,
        },
        {
          text: this.$i18n.t("Status"),
          align: "left",
          value: "status",
          width: "8%",
        },
      ];
    },
  },

  methods: {
    ...mapActions(["fetchAllUsers"]),

    async getAllUsers() {
      try {
        let resp = await this.fetchAllUsers();
        this.setUsers(resp.data.data);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    setUsers(users) {
      const webUsers = [];
      const mobileUsers = [];
      users.forEach((user) => {
        user.name = user.first_name + " " + user.last_name;
        user.name = user.name.replace("null", "");
        if (user.type === "web") {
          webUsers.push(user);
        }
        if (user.type === "mobile") {
          mobileUsers.push(user);
        }
      });
      this.usersWeb = [...webUsers];
      this.usersMobile = [...mobileUsers];
    },

    pushUser(user) {
      user.name = user.first_name + " " + user.last_name;
      user.name = user.name.replace("null", "");
      if (user.type === "web") {
        this.usersWeb.push(user);
      }
      if (user.type === "mobile") {
        this.usersMobile.push(user);
      }
    },

    getName(user) {
      if (user.last_name) {
        return user.first_name + " " + user.last_name;
      } else {
        return user.first_name;
      }
    },

    isActive(status) {
      return status === "active" || status === true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/management/userListsMixin.js